import * as React from 'react';

interface Props {
  onChange: any;
  style?: React.CSSProperties;
}

const ImagePicker: React.SFC<Props> = ({ onChange, style }: Props) => (
  <div>
    <label style={{ fontSize: '1rem' }}>Bildgröße max. 3 MB, jpg-Datei</label>
    <input type="file" onChange={onChange} accept="image/jpeg" style={style} />
  </div>
);

export default ImagePicker;



// WEBPACK FOOTER //
// ./src/components/utils/ImagePicker/ImagePicker.tsx